import React, {Component} from 'react'
import Slide from '../Globals/Slide/slide'
import Asigancion from './asignacionViajes'
import Diponiblidad from './disponibilidad'
import Unidades from './unidades'
import taxi from '../../img/taxiW.png'
import unidDisp from '../../img/auto.png'
import asigViaj from '../../img/checkW.png'
import ubicViaj from '../../img/ubicacion.png'
import './estilo.css';
import store from '../../store';

class PlaniViajes extends Component{
    constructor(props){
        super(props);
        this.state={

        };
    }

    ocultarMenu(){
		store.dispatch({	
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}

    render(){
        return(
            <div onClick={this.ocultarMenu}>  
                <div style={{marginTop:20}} className="container">

                    <div className="row">
                    <div className="col-1">
                        <img src={taxi} />
                    </div>
                    <div className="col-11">
                        <h3 className="title-blue">Monitoreo de viajes</h3>
                        <span className="text-info">Visualización de unidades y control de viajes</span>
                    </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <ul className="nav nav-tabs m-bottom flex-column flex-md-row justify-content-end" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active show" id="unidades-tab" data-toggle="tab" href="#unidades" role="tab"
                                aria-controls="unidades" aria-selected="true"><img src={unidDisp}/> Unidades asignadas</a>
                            </li>
                            {/* <li className="nav-item">
                                <a className="nav-link" id="asignacion-tab" data-toggle="tab" href="#asignacion" role="tab" aria-controls="asignacion"
                                aria-selected="false"><img src={asigViaj}/> Asignación de viajes</a>
                            </li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade active show" id="unidades" role="tabpanel" aria-labelledby="unidades-tab">
                                <Unidades
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyATad9mdS85bZPesVOnJpSP3BSwVAg60aY&v=3.exp&libraries=geometry,drawing,places"
                                    loadingElement={<div style={{ height: '600px',  }} />}
                                    containerElement={<div  />}
                                    mapElement={<div style={{ height: '500px',width:'45rem' }} />}
                                />
                            </div>

                            <div className="tab-pane fade" id="asignacion" role="tabpanel" aria-labelledby="asignacion-tab">
                                <Asigancion/>
                            </div>

                        </div>
                </div>
            </div>
        )
    }
}
export default PlaniViajes;


// WEBPACK FOOTER //
// ./src/Components/PlanificacionE/planiViajes.js